import FormData from 'form-data';

import { authSetFile } from '../../utils/request';

export const editorTemplates = [
  {
    title: 'Article template',
    description: 'Base part of article',
    content: '<p class="main_title" style="font-size: 80px; font-weight: bold;">Performance Series coilovers'
            + ' vs. Bilstein'
            + ' 6112 struts</p>\n'
            + '<p>The showdown in-between American Fox 2.0 Performance Series coilovers and German '
        + 'Bilstein 6112 struts is going to be a promising one for all suspension performance fans.</p>\n'
            + '<p><img src="https://image-resize-api.s3.us-west-1.amazonaws.com/articles/1656512578_main.jpg" '
        + 'alt="" width="100%" height="100%"></p>\n'
            + '<p class="sub_title" style="font-size: 80px; font-weight: bold;">In General</p>\n'
            + '<p style="text-align: justify;">Both the internet and suspension-modding community '
        + 'are rife with debates about '
        + 'which products in the Fox 2.0 Performance Series coilovers vs. Bilstein 6112 struts '
        + 'comparison are better. The first have been used by SUV and pickup truck owners'
        + ' for quite some time now, offering such options as spring collars,'
        + ' used for easy height adjustment, coupled with simple and effortless installation.'
        + ' The second are a relative newcomer on the scene, while offering durable &amp; sturdy 2.6" shocks,'
        + ' capable of taking onto just about any competing product, while being designed for heavy-duty use, which'
        + ' is encountered during off-roading and 4x4ing.</p>\n'
            + '<p><img style="display: block; margin-left: auto; margin-right: auto;"'
        + ' src="https://image-resize-api.s3.us-west-1.amazonaws.com/articles/1656513363_main.jpg" '
        + 'alt="" width="815" height="517"></p>\n'
            + '<p style="font-size: 16px; font-weight: 400; color: #7a7e86;">Whether on a model car or a real one,'
        + ' compromised springs can create an uneven vehicle stance,'
        + ' crooked alignment, and unstable handling - among other problems.</p>'
  },
  {
    title: 'Main header',
    description: 'Default main header.',
    content: '<p class="main_title" style="font-size: 80px;font-weight: 700">Default main header text</p>'
  },
  {
    title: 'Sub header',
    description: 'Default sub header.',
    content: '<p class="sub_title" style="font-size: 48px;font-weight: 700">Default main header text</p>'
  },
  {
    title: 'Image note text',
    description: 'Default image note text.',
    content: '<p style="font-size: 16px;font-weight: 400;color: #7A7E86;">Default image note text</p>'
  },
];

const imagesUploadHandler = async (blobInfo, success) => {
  const formData = new FormData();
  formData.append('file', blobInfo.blob());

  const data = await authSetFile('/general/uploadToS3', formData, {
    'Content-Type': 'multipart/formdata',
  });
  success(data.location);
};

export const editorInit = {
  selector: '#tinyEditor',
  font_formats:
      'Arial Black=arial black,avant garde; Courier New=courier new,courier; Lato Black=lato;'
      + " Roboto='Roboto',sans-serif",
  height: 500,
  plugins: ['image', 'anchor', 'codesample', 'fullscreen',
    'advlist', 'autolink', 'fullscreen', 'help',
    'lists', 'link', 'preview',
    'searchreplace', 'table', 'template', 'visualblocks', 'wordcount', 'code'
  ],
  toolbar: 'undo redo | fontselect| h1 h2 h3 h4 h5 | bold italic '
      + '| link image forecolor backcolor | template codesample'
      + ' codes |'
      + ' alignleft aligncenter alignright alignjustify | bullist numlist |',
  content_style: '@import'
      + ' url(\'@import url(\'https://fonts.googleapis.com/'
      + 'css2?family=Roboto:wght@400;700&display=swap\');\');'
      + 'body { font-family:\'Roboto\','
      + 'sans-serif; font-size:24px;color:#212936}',
  toolbar_mode: 'floating',
  file_picker_types: 'file image media',
  templates: editorTemplates,
  images_upload_handler: imagesUploadHandler,
};
